/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RateReliefCalculatorServiceResponse
 */
export interface RateReliefCalculatorServiceResponse {
    /**
     * 
     * @type {string}
     * @memberof RateReliefCalculatorServiceResponse
     */
    policyNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RateReliefCalculatorServiceResponse
     */
    rateReliefAvailable?: number;
    /**
     * 
     * @type {number}
     * @memberof RateReliefCalculatorServiceResponse
     */
    crntPremEqColQ?: number;
    /**
     * 
     * @type {number}
     * @memberof RateReliefCalculatorServiceResponse
     */
    crntIncreaseColW?: number;
    /**
     * 
     * @type {number}
     * @memberof RateReliefCalculatorServiceResponse
     */
    newPremEqColX?: number;
    /**
     * 
     * @type {number}
     * @memberof RateReliefCalculatorServiceResponse
     */
    newPremEqWrr?: number;
    /**
     * 
     * @type {number}
     * @memberof RateReliefCalculatorServiceResponse
     */
    rrIncrease?: number;
    /**
     * 
     * @type {number}
     * @memberof RateReliefCalculatorServiceResponse
     */
    actRrDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof RateReliefCalculatorServiceResponse
     */
    bankAmountUsed?: number;
    /**
     * 
     * @type {number}
     * @memberof RateReliefCalculatorServiceResponse
     */
    maxReliefNoComp?: number;
    /**
     * 
     * @type {number}
     * @memberof RateReliefCalculatorServiceResponse
     */
    maxReliefWSFComp?: number;
    /**
     * 
     * @type {number}
     * @memberof RateReliefCalculatorServiceResponse
     */
    maxReliefWFIComp?: number;
    /**
     * 
     * @type {string}
     * @memberof RateReliefCalculatorServiceResponse
     */
    optionsEligible?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RateReliefCalculatorServiceResponse
     */
    compQuoteNeededForAdditionalRelief?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RateReliefCalculatorServiceResponse
     */
    increasePriorToAggressiveRating?: number;
}

/**
 * Check if a given object implements the RateReliefCalculatorServiceResponse interface.
 */
export function instanceOfRateReliefCalculatorServiceResponse(value: object): value is RateReliefCalculatorServiceResponse {
    return true;
}

export function RateReliefCalculatorServiceResponseFromJSON(json: any): RateReliefCalculatorServiceResponse {
    return RateReliefCalculatorServiceResponseFromJSONTyped(json, false);
}

export function RateReliefCalculatorServiceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateReliefCalculatorServiceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'policyNumber': json['policyNumber'] == null ? undefined : json['policyNumber'],
        'rateReliefAvailable': json['rateReliefAvailable'] == null ? undefined : json['rateReliefAvailable'],
        'crntPremEqColQ': json['crntPremEqColQ'] == null ? undefined : json['crntPremEqColQ'],
        'crntIncreaseColW': json['crntIncreaseColW'] == null ? undefined : json['crntIncreaseColW'],
        'newPremEqColX': json['newPremEqColX'] == null ? undefined : json['newPremEqColX'],
        'newPremEqWrr': json['newPremEqWrr'] == null ? undefined : json['newPremEqWrr'],
        'rrIncrease': json['rrIncrease'] == null ? undefined : json['rrIncrease'],
        'actRrDiscount': json['actRrDiscount'] == null ? undefined : json['actRrDiscount'],
        'bankAmountUsed': json['bankAmountUsed'] == null ? undefined : json['bankAmountUsed'],
        'maxReliefNoComp': json['maxReliefNoComp'] == null ? undefined : json['maxReliefNoComp'],
        'maxReliefWSFComp': json['maxReliefWSFComp'] == null ? undefined : json['maxReliefWSFComp'],
        'maxReliefWFIComp': json['maxReliefWFIComp'] == null ? undefined : json['maxReliefWFIComp'],
        'optionsEligible': json['optionsEligible'] == null ? undefined : json['optionsEligible'],
        'compQuoteNeededForAdditionalRelief': json['compQuoteNeededForAdditionalRelief'] == null ? undefined : json['compQuoteNeededForAdditionalRelief'],
        'increasePriorToAggressiveRating': json['increasePriorToAggressiveRating'] == null ? undefined : json['increasePriorToAggressiveRating'],
    };
}

export function RateReliefCalculatorServiceResponseToJSON(json: any): RateReliefCalculatorServiceResponse {
    return RateReliefCalculatorServiceResponseToJSONTyped(json, false);
}

export function RateReliefCalculatorServiceResponseToJSONTyped(value?: RateReliefCalculatorServiceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'policyNumber': value['policyNumber'],
        'rateReliefAvailable': value['rateReliefAvailable'],
        'crntPremEqColQ': value['crntPremEqColQ'],
        'crntIncreaseColW': value['crntIncreaseColW'],
        'newPremEqColX': value['newPremEqColX'],
        'newPremEqWrr': value['newPremEqWrr'],
        'rrIncrease': value['rrIncrease'],
        'actRrDiscount': value['actRrDiscount'],
        'bankAmountUsed': value['bankAmountUsed'],
        'maxReliefNoComp': value['maxReliefNoComp'],
        'maxReliefWSFComp': value['maxReliefWSFComp'],
        'maxReliefWFIComp': value['maxReliefWFIComp'],
        'optionsEligible': value['optionsEligible'],
        'compQuoteNeededForAdditionalRelief': value['compQuoteNeededForAdditionalRelief'],
        'increasePriorToAggressiveRating': value['increasePriorToAggressiveRating'],
    };
}

